(function () {
  "use strict";

  document.querySelectorAll(".suture-finder").forEach(initSutureFinder);

  function initSutureFinder(root) {
    var state = { data: null, loaded: false, loading: false };

    // ---- Lazy-load the catalog JSON only when the tool nears the viewport ----
    var loadingEl = root.querySelector("[data-loading]");

    function loadData() {
      if (state.loading || state.loaded) return Promise.resolve(state.data);
      state.loading = true;
      if (loadingEl) loadingEl.hidden = false;
      return fetch(root.dataset.jsonUrl)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          state.data = json;
          state.loaded = true;
          if (loadingEl) loadingEl.hidden = true;
          populateFilters(root, json);
          return json;
        })
        .catch(function (err) {
          if (loadingEl) { loadingEl.hidden = false; loadingEl.textContent = "Couldn't load catalog data. Please refresh."; }
          console.error("Suture Finder:", err);
        });
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadData(); io.disconnect(); }
        });
      }, { rootMargin: "200px" });
      io.observe(root);
    } else {
      loadData();
    }

    // ---- Tabs ----
    var tabs = root.querySelectorAll(".suture-finder__tab");
    var panels = root.querySelectorAll(".suture-finder__panel");
    var defaultTab = window.sutureFinderDefaultTab || "search";

    function selectTab(name) {
      tabs.forEach(function (t) {
        var active = t.dataset.tab === name;
        t.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== name; });
    }
    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        selectTab(t.dataset.tab);
        loadData();
      });
    });
    selectTab(defaultTab);

    // ---- Search by item number / brand ----
    var searchInput = root.querySelector('[data-panel="search"] .suture-finder__input');
    var searchResults = root.querySelector('[data-results="search"]');
    var searchDebounce;
    searchInput.addEventListener("input", function () {
      clearTimeout(searchDebounce);
      searchDebounce = setTimeout(function () {
        loadData().then(function (data) {
          if (!data) return;
          runSearch(data, searchInput.value.trim(), searchResults);
        });
      }, 150);
    });

    function runSearch(data, query, container) {
      if (!query) { container.innerHTML = ""; return; }
      var q = query.toLowerCase();

      // First pass: is the query an exact hit against any row's SKU (mfr or Delasco)?
      // If so, only show that row's group -- don't dilute results with substring collisions.
      var exactHits = data.filter(function (row) {
        return (row.sku && row.sku.toLowerCase() === q) ||
               (row.delasco_sku && row.delasco_sku.toLowerCase() === q);
      });

      var directMatches;
      if (exactHits.length) {
        directMatches = exactHits;
      } else {
        // No exact SKU hit -- fall back to substring search across SKU / brand / trade name / description
        directMatches = data.filter(function (row) {
          var haystacks = [row.sku, row.delasco_sku, row.brand, row.trade_name, row.description]
            .filter(Boolean).map(function (s) { return String(s).toLowerCase(); });
          return haystacks.some(function (h) { return h.indexOf(q) !== -1; });
        });
      }

      if (!directMatches.length) {
        container.innerHTML = '<div class="sf-empty">No matches. Try a different item number or brand name.</div>';
        return;
      }

      // Group the matches by xref_group so multiple hits in the same group don't duplicate a card
      var byGroup = {};
      directMatches.forEach(function (row) {
        (byGroup[row.xref_group] = byGroup[row.xref_group] || []).push(row);
      });

      var groupIds = Object.keys(byGroup);
      container.innerHTML = groupIds.slice(0, 15).map(function (groupId) {
        var matchedRows = byGroup[groupId];
        var isExact = matchedRows.some(function (row) {
          return (row.sku && row.sku.toLowerCase() === q) ||
                 (row.delasco_sku && row.delasco_sku.toLowerCase() === q);
        });
        // special_order rows only surface here if they were an exact match themselves
        var eligibleMatched = matchedRows.filter(function (row) {
          return row.status !== "special_order" || isExact;
        });
        var stockedInGroup = data.filter(function (row) {
          return row.xref_group === groupId && row.status === "stocked" &&
                 !eligibleMatched.some(function (m) { return m.sku === row.sku; });
        });
        var rowsToShow = eligibleMatched.concat(stockedInGroup);
        if (!rowsToShow.length) return "";
        return renderCardSet(data, groupId, rowsToShow);
      }).join("");
      attachCardHandlers(container);
    }

    // ---- Browse by category ----
    var materialSelect = root.querySelector("[data-material-select]");
    var browseResults = root.querySelector('[data-results="browse"]');
    materialSelect.addEventListener("change", function () {
      loadData().then(function (data) {
        renderBrowse(data, materialSelect.value, browseResults);
      });
    });

    function renderBrowse(data, material, container) {
      if (!material) { container.innerHTML = ""; return; }
      var groupIds = uniq(data.filter(function (r) { return r.material === material; })
        .map(function (r) { return r.xref_group; }));
      if (!groupIds.length) {
        container.innerHTML = '<div class="sf-empty">No items found for this material.</div>';
        return;
      }
      container.innerHTML = groupIds.map(function (g) { return renderGroup(data, g, { allowSpecialOrder: false }); }).join("");
      attachCardHandlers(container);
    }

    // ---- Find by specification ----
    var attrSelects = root.querySelectorAll("[data-attr]");
    var attrResults = root.querySelector('[data-results="attributes"]');
    attrSelects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        loadData().then(function (data) { runAttributeFilter(data); });
      });
    });

    function runAttributeFilter(data) {
      var filters = {};
      attrSelects.forEach(function (sel) { if (sel.value) filters[sel.dataset.attr] = sel.value; });
      if (!Object.keys(filters).length) { attrResults.innerHTML = ""; return; }

      var matches = data.filter(function (row) {
        if (row.status !== "stocked") return false;
        return Object.keys(filters).every(function (key) { return row[key] === filters[key]; });
      });

      if (!matches.length) {
        attrResults.innerHTML = '<div class="sf-empty">No stocked items match that combination. Try loosening a filter.</div>';
        return;
      }
      attrResults.innerHTML = '<div class="sf-chain">' + matches.map(cardHtml).join("") + "</div>";
      attachCardHandlers(attrResults);
    }

    // ---- Shared rendering ----
    // Browse mode: show every stocked + reference row in the group (full cross-reference view)
    function renderGroup(data, groupId, opts) {
      opts = opts || {};
      var rows = data.filter(function (r) { return r.xref_group === groupId; });
      if (!rows.length) return "";
      var visibleRows = rows.filter(function (r) { return r.status !== "special_order" || opts.allowSpecialOrder; });
      return renderCardSet(data, groupId, visibleRows);
    }

    // Search mode: show a specific, pre-selected set of rows (matched item + stocked equivalents only)
    function renderCardSet(data, groupId, rows) {
      if (!rows.length) return "";
      var spec = rows[0];
      var specLine = [
        spec.material ? "<strong>" + esc(spec.material) + "</strong>" : null,
        spec.gauge ? "Gauge " + esc(spec.gauge) : null,
        spec.needle_code ? "Needle " + esc(spec.needle_code) : null,
        spec.strand_length ? esc(spec.strand_length) : null,
        spec.color ? esc(spec.color) : null
      ].filter(Boolean).join(" &nbsp;·&nbsp; ");

      var hasStocked = rows.some(function (r) { return r.status === "stocked"; });

      return (
        '<div class="sf-group">' +
          '<div class="sf-group__spec">' + specLine + "</div>" +
          '<div class="sf-chain">' + rows.map(cardHtml).join("") + "</div>" +
          (hasStocked ? "" : '<div class="sf-card__note" style="margin-top:10px;">We don\u2019t currently stock this exact spec.' +
            ' <a class="sf-request-btn" href="mailto:questions@delasco.com?subject=Suture%20request%20-%20' + encodeURIComponent(groupId) + '">Request this item</a></div>') +
        "</div>"
      );
    }

    function cardHtml(row) {
      var badgeClass = "sf-badge--" + row.status;
      var badgeLabel = row.status === "stocked" ? "In Stock" : row.status === "reference" ? "Reference Only" : "Special Order";
      var isStocked = row.status === "stocked";
      var priceHtml = isStocked && row.price != null ? '<div class="sf-card__price">$' + Number(row.price).toFixed(2) + "</div>" : "";
      var actionHtml;
      if (isStocked && row.shopify_handle) {
        actionHtml = '<button type="button" class="sf-add-btn" data-add-to-cart data-handle="' + esc(row.shopify_handle) + '">Add to Cart</button>';
      } else if (isStocked) {
        actionHtml = '<button type="button" class="sf-add-btn" disabled>Product link pending</button>';
      } else if (row.status === "special_order") {
        actionHtml = '<a class="sf-request-btn" href="mailto:questions@delasco.com?subject=Special%20order%20-%20' + encodeURIComponent(row.sku) + '">Ask about ordering this</a>';
      } else {
        actionHtml = '<span class="sf-card__note">Not sold by Delasco</span>';
      }

      // Show the number a customer actually orders by: Delasco's own item number when we carry it,
      // otherwise the brand's own catalog number (for reference/special-order rows).
      var displaySku = row.delasco_sku || row.sku;
      var imageHtml = row.image_url
        ? '<img class="sf-card__img" src="' + esc(row.image_url) + '" alt="" loading="lazy">'
        : '<div class="sf-card__img sf-card__img--placeholder" aria-hidden="true"></div>';

      return (
        '<div class="sf-card' + (isStocked ? " sf-card--stocked" : "") + '">' +
          imageHtml +
          '<div class="sf-card__brand">' + esc(row.brand) + "</div>" +
          '<div class="sf-card__sku">' + esc(row.trade_name ? row.trade_name + " \u2014 " + displaySku : displaySku) + "</div>" +
          '<div class="sf-badge ' + badgeClass + '">' + badgeLabel + "</div>" +
          '<div class="sf-card__desc">' + esc(row.description || "") + "</div>" +
          priceHtml +
          actionHtml +
        "</div>"
      );
    }

    function attachCardHandlers(container) {
      container.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
        btn.addEventListener("click", function () { addToCart(btn); });
      });
    }

    function addToCart(btn) {
      var handle = btn.dataset.handle;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = "Adding\u2026";
      fetch("/products/" + handle + ".js")
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variantId = product.variants && product.variants[0] && product.variants[0].id;
          if (!variantId) throw new Error("No variant found");
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error("Add to cart failed");
          btn.textContent = "Added \u2713";
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800);
        })
        .catch(function (err) {
          console.error("Suture Finder add-to-cart:", err);
          btn.textContent = "Couldn't add \u2014 retry";
          btn.disabled = false;
        });
    }

    function populateFilters(root, data) {
      // Category browse dropdown
      var materials = uniq(data.map(function (r) { return r.material; }).filter(Boolean)).sort();
      materialSelect.innerHTML = '<option value="">Select a material\u2026</option>' +
        materials.map(function (m) { return '<option value="' + esc(m) + '">' + esc(m) + "</option>"; }).join("");

      // Attribute finder dropdowns (only from stocked rows, since that's what this mode searches)
      var stocked = data.filter(function (r) { return r.status === "stocked"; });
      attrSelects.forEach(function (sel) {
        var key = sel.dataset.attr;
        var values = uniq(stocked.map(function (r) { return r[key]; }).filter(Boolean)).sort();
        var current = sel.innerHTML;
        sel.innerHTML = '<option value="">Any</option>' +
          values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + "</option>"; }).join("");
      });
    }

    function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
  }
})();